function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect } from 'react';
import { ScrollView, Stack, View } from 'native-base';
import { ContextProvider } from 'fmc-digital-common';
import { LIPToastMessage, LoanOverview, LoanStatusContainer, TaskSection } from '../organisms';
import { useLipStore } from '../../reducers';
import LoanStatusInfoCard from '../organisms/LoanStatusInfoCard';
import { isEnableInfoCard } from '../../utils';
import { Platform } from 'react-native';
import { LoanBanner } from '../molecules';
export const LoanInProgressScreen = ({
  setShowUploadModalWeb,
  widgets,
  isNtbRequired,
  ...rest
}) => {
  const {
    isShowDocUploadModalWeb,
    toastMessageProps: toastMessages,
    clearToastMessageProps,
    clearUploadedFiles,
    setEsignToastMessage,
    toastmessageEsign
  } = useLipStore(state => state);
  const isTaskSection = widgets?.includes('loan-in-progress-task') || false;
  const isStatusTrackerSection = widgets?.includes('status_tracker_widget') || false;
  useEffect(() => {
    if (setShowUploadModalWeb) {
      setShowUploadModalWeb(isShowDocUploadModalWeb);
    }
  }, [isShowDocUploadModalWeb, setShowUploadModalWeb]);
  useEffect(() => {
    if (toastMessages.length > 0) {
      setTimeout(() => {
        clearToastMessageProps();
        clearUploadedFiles();
      }, 8000);
    } else if (toastmessageEsign.isShowToastMessage) {
      setTimeout(() => {
        setEsignToastMessage({
          ...toastmessageEsign,
          isShowToastMessage: false
        });
      }, 8000);
    }
  }, [toastMessages, clearToastMessageProps, clearUploadedFiles, toastmessageEsign, setEsignToastMessage]);
  const getTaskSection = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    justifyContent: {
      md: 'space-between',
      base: undefined,
      lg: undefined
    },
    mb: {
      base: '0',
      md: '2',
      sm: '0'
    },
    direction: {
      base: 'column',
      md: 'column',
      lg: 'column',
      sm: 'column',
      xl: 'row'
    },
    space: {
      base: '2',
      md: '2',
      lg: '2',
      sm: '2',
      xl: '8'
    }
  }, /*#__PURE__*/React.createElement(LoanOverview, rest), isStatusTrackerSection ? /*#__PURE__*/React.createElement(LoanStatusContainer, rest) : /*#__PURE__*/React.createElement(React.Fragment, null)), isEnableInfoCard(rest.loanStatus) ? /*#__PURE__*/React.createElement(LoanStatusInfoCard, rest) : null, isTaskSection ? /*#__PURE__*/React.createElement(TaskSection, _extends({
    widgets: widgets
  }, rest)) : /*#__PURE__*/React.createElement(React.Fragment, null));
  return /*#__PURE__*/React.createElement(ContextProvider, null, Platform.OS === 'web' ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(LoanBanner, {
    isNtbRequired: isNtbRequired,
    loanNumber: rest.loanNumber
  }), getTaskSection()) : /*#__PURE__*/React.createElement(ScrollView, null, getTaskSection()), /*#__PURE__*/React.createElement(LIPToastMessage, null));
};
export default LoanInProgressScreen;
//# sourceMappingURL=LoanInProgressScreen.js.map